// extracted by mini-css-extract-plugin
module.exports = {"root":"_1mVrb70Q2RnYz4NBuOOkkW","skillPercentage":"_2BR_2HwAV_8K7SjKmtmVBq","inactiveSkill":"_2QkXqCgYo0g9duLy6VgY-Y"};